var map = {
	"./Card/Card/index.js": 1395,
	"./Card/CardVideo/index.js": 1396,
	"./Drawer/DrawerMenu/index.js": 1397,
	"./Entity/EntityProfileMap/index.js": 1398,
	"./Hotline/HotlineActivity/index.js": 1399,
	"./Hotline/HotlineActivityQuery/index.js": 1400,
	"./Hotline/HotlineActivityQueryInterface/index.js": 1401,
	"./Hotline/HotlineActivityQueryStorage/index.js": 1402,
	"./Hotline/HotlineActivityQueryToday/index.js": 1403,
	"./Layout/AsideDrawerMenu/index.js": 1404,
	"./Layout/AsideMenuMain/index.js": 1405,
	"./Layout/BackgroundImage/index.js": 1406,
	"./Layout/GridCentered/index.js": 1407,
	"./Layout/HeaderActions/index.js": 1408,
	"./Layout/NotificationToast/index.js": 1409,
	"./Layout/TemplateNotifications/index.js": 1410,
	"./Link/LinkIcon/index.js": 1411,
	"./Link/LinkIconContext/index.js": 1412,
	"./Link/LinkIconSimple/index.js": 1413,
	"./Link/LinkIconSimpleUserContext/index.js": 1414,
	"./Map/MapAdvanced/index.js": 1416,
	"./Map/MapAdvancedCompose/index.js": 1418,
	"./Map/MapSimple/index.js": 1420,
	"./Map/MarkerPopover/index.js": 1421,
	"./Menu/MenuAsideItem/index.js": 1422,
	"./Organization/OrganizationAdd/index.js": 1423,
	"./Organization/OrganizationAddFull/index.js": 1424,
	"./Organization/OrganizationAddFullDescription/index.js": 1425,
	"./Organization/OrganizationCard/index.js": 1426,
	"./Organization/OrganizationFirestoreDocument/index.js": 1427,
	"./Organization/OrganizationFirestoreList/index.js": 1428,
	"./Organization/OrganizationFirestormSync/index.js": 1429,
	"./Organization/OrganizationMap/index.js": 1430,
	"./Organization/OrganizationMapSlim/index.js": 1431,
	"./Organization/OrganizationProfileGraphRequest/index.js": 1432,
	"./Organization/OrganizationProfileInterface/index.js": 1433,
	"./Organization/OrganizationProfileInterfaceBiography/index.js": 1434,
	"./Organization/OrganizationProfileInterfaceIdentity/index.js": 1435,
	"./Organization/OrganizationSearchAdvanced/index.js": 1436,
	"./Organization/OrganizationSearchLocal/index.js": 1437,
	"./Organizations/OrganizationsMapMarkers/index.js": 1439,
	"./People/PeopleAddFullDescription/index.js": 1440,
	"./People/PeopleFirestoreList/index.js": 1441,
	"./People/PeopleMap/index.js": 1442,
	"./People/PeopleMapSlim/index.js": 1443,
	"./People/PeopleMarkerPopover/index.js": 1444,
	"./People/PeopleSearchAdvanced/index.js": 1445,
	"./People/PersonFirestoreDocument/index.js": 1446,
	"./Person/PersonAdd/index.js": 1447,
	"./Person/PersonAddFull/index.js": 1448,
	"./Person/PersonCard/index.js": 1449,
	"./Person/PersonMarkerPopover/index.js": 1450,
	"./Person/PersonProfileInterface/index.js": 1451,
	"./Person/PersonProfileInterfaceBiography/index.js": 1452,
	"./Person/PersonProfileInterfaceIdentity/index.js": 1453,
	"./Project/ProjectAdd/index.js": 1454,
	"./Project/ProjectAddFull/index.js": 1455,
	"./Project/ProjectAddFullDescription/index.js": 1456,
	"./Project/ProjectCard/index.js": 1457,
	"./Project/ProjectFirestoreDocument/index.js": 1458,
	"./Project/ProjectMarkerPopover/index.js": 1459,
	"./Project/ProjectProfileInterface/index.js": 1460,
	"./Project/ProjectProfileInterfaceBiography/index.js": 1461,
	"./Project/ProjectProfileInterfaceIdentity/index.js": 1462,
	"./Projects/ProjectsFirestoreList/index.js": 1463,
	"./Projects/ProjectsMap/index.js": 1464,
	"./Projects/ProjectsMapSlim/index.js": 1465,
	"./Projects/ProjectsSearchAdvanced/index.js": 1466,
	"./Query/QueryUsers/index.js": 1467,
	"./Query/QueryUsersInterface/index.js": 1468,
	"./Query/QueryUsersInternal/index.js": 1469,
	"./Resource/ResourceAdd/index.js": 1471,
	"./Resource/ResourceAddFullDescription/index.js": 1472,
	"./Resource/ResourceCard/index.js": 1473,
	"./Resource/ResourceFirestoreDocument/index.js": 1474,
	"./Resource/ResourceMarkerPopover/index.js": 1475,
	"./Resource/ResourceProfileInterface/index.js": 1476,
	"./Resource/ResourceProfileInterfaceBiography/index.js": 1477,
	"./Resource/ResourceProfileInterfaceIdentity/index.js": 1478,
	"./Resources/ResourcesFirestoreList/index.js": 1479,
	"./Resources/ResourcesMap/index.js": 1480,
	"./Resources/ResourcesMapSlim/index.js": 1481,
	"./Resources/ResourcesSearchAdvanced/index.js": 1482,
	"./User/UserGraph/index.js": 1483,
	"./User/UserProfile/index.js": 1484,
	"./User/UserProfileAddress/index.js": 1485,
	"./User/UserProfileBiography/index.js": 1486,
	"./User/UserProfileDashboard/index.js": 1487,
	"./User/UserProfileDashboardRequest/index.js": 1488,
	"./User/UserProfileSimple/index.js": 1489,
	"./Wallet/WalletAddress/index.js": 1490
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3313;


//////////////////
// WEBPACK FOOTER
// ./src/interface/foundry \.\/[^\/]+\/[^\/]+\/index\.js$
// module id = 3313
// module chunks = 0